import { ResolveFn } from '@angular/router';

export const botoriginResolver: ResolveFn<string> = (route) => {
  if (route.params['origin']) {
    return route.params['origin'] as string;
  } else {
    return '';
  }
};
